<template>
  <!-- base component - like dynamic dialog, other components should  extend for layout -->
  <v-dialog
    v-model="internalDialog"
    fullscreen
    persistent
    scroll-strategy="block"
  >
    <v-card>
      <!-- Dialog Title -->
      <v-toolbar
        flat
        :style="
          'background-color: ' +
          this.$store.state.config.siteConfig.toolbar_colour
        "
        class="dynamicTextColour"
      >
        <v-btn
          icon
          @click="
            $emit('dialogCancel');
            internalDialog = false;
          "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <slot name="title">Dialog Title</slot>
        </v-toolbar-title>
      </v-toolbar>

      <!-- Dialog Body -->
      <v-card-text class="pa-0 dialog-body">
        <div class="responsive-flex">
          <!-- Left Column -->
          <div class="column left-col">
            <slot name="left-col">Left Column Content</slot>
          </div>

          <!-- Right Column -->
          <div class="column right-col">
            <slot name="right-col">Right Column Content</slot>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Dialog Footer -->
      <v-card-actions class="d-flex justify-space-between">
        <slot name="footer-left">
          <v-btn
            variant="text"
            @click="
              $emit('dialogCancel');
              internalDialog = false;
            "
            >Cancel</v-btn
          >
        </slot>

        <slot name="footer-center">
          <div class="flex-grow-1"></div>
        </slot>

        <slot name="footer-right">
          <v-btn color="success" variant="flat" @click="$emit('dialogOk')"
            >Ok</v-btn
          >
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogTwoColFullscreen",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    internalDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
/* Make v-card a column so the body can flex */
:deep(.v-card) {
  display: flex;
  flex-direction: column;
}

.dialog-body {
  /* flex instead of a hard inline height calc */
  flex: 1 1 auto;
  min-height: 0;
}

.responsive-flex {
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  flex-wrap: nowrap; /* important: no wrapping */
}

.column {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-sizing: border-box;
  min-height: 0; /* Important to prevent overflow */
  display: flex;
  flex-direction: column;
}

.left-col,
.right-col {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0; /* critical for nested scrolling */
  overflow: visible; /* keep scrollbars in children */
}
/* Large screen: 75% / 25% */
@media (min-width: 961px) {
  .left-col {
    flex: 0 0 calc(75% - 8px);
  }
  .right-col {
    flex: 0 0 calc(25% - 8px);
  }
}

/* Small screen: Stack */
@media (max-width: 960px) {
  .responsive-flex {
    flex-direction: column;
  }
  .left-col,
  .right-col {
    flex: 1 1 auto;
    width: 100%;
  }
}
</style>
